import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  setPersistence, 
  browserSessionPersistence,
  updateCurrentUser
} from "firebase/auth";
import { 
  getFirestore, 
  enableIndexedDbPersistence 
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBFvxUYmoS9CmgfLRKGu-t9WHczfNRCSnk",
  authDomain: "certificadosapp-63ae1.firebaseapp.com",
  projectId: "certificadosapp-63ae1",
  storageBucket: "certificadosapp-63ae1.appspot.com",
  messagingSenderId: "1024472197826",
  appId: "1:1024472197826:web:55b9cf6fb2c42c6a63695b"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserSessionPersistence)
  .catch((error) => {
    console.error("Error configurando persistencia:", error);
  });

export const db = getFirestore(app);
enableIndexedDbPersistence(db)
  .catch((error) => {
    if (error.code === 'failed-precondition') {
      console.warn("Persistencia offline no disponible en múltiples pestañas");
    } else if (error.code === 'unimplemented') {
      console.warn("Persistencia no soportada en este navegador");
    }
  });

export const restoreOriginalUser = async (originalUser) => {
  try {
    await updateCurrentUser(auth, originalUser);
    await originalUser.getIdToken(true);
  } catch (error) {
    console.error("Error restaurando sesión:", error);
    throw error;
  }
};